import React, { useId } from "react";

/** Single vector “T” mark — pairs with the wordmark (no raster logo). */
const HomeRpgLogoMark = () => {
  const uid = useId().replace(/:/g, "");
  const gradId = `tdRpgGold-${uid}`;
  const glowId = `tdRpgGlow-${uid}`;

  return (
    <svg
      className="td-rpg-logo__mark"
      viewBox="0 0 32 36"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable="false"
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f4ecd0" />
          <stop offset="50%" stopColor="#c9a54a" />
          <stop offset="100%" stopColor="#6d5420" />
        </linearGradient>
        <filter id={glowId} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <path
        fill={`url(#${gradId})`}
        filter={`url(#${glowId})`}
        d="M1 3h30v4H18.5v25h-5V7H1V3z"
      />
    </svg>
  );
};

export default HomeRpgLogoMark;
